function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { useWizard } from 'react-use-wizard';
import PaymentMethodStep from '../../../components/wizard/PaymentMethodStep';
import { LEAD_PAYMENT_PAGE } from '../../../constants/job';
import { PAY_MODE } from '../../../constants/order';
import useBreakpoint from '../../../hooks/useBreakpoint';
import { sendLead } from '../../../redux/actions';
import { assignPayment, createDiscountCode, setPaymentMethodId, setSelectedPayMode } from '../../../redux/actions/order';
import routes from '../../../routes/constants';
import text from '../../../text';
import { amplitudeTrack } from '../../../utilities';
import { AMPLITUDE_EVENTS } from '../../../constants/analytics';
var PAYMENT_FLOW = AMPLITUDE_EVENTS.PAYMENT_FLOW;
var OrderWizardPaymentMethod = function() {
    var history = useHistory();
    var dispatch = useDispatch();
    var nextStep = useWizard().nextStep;
    var jobId = useParams().jobId;
    var isBreakpointEnabled = useBreakpoint([
        'xs',
        'sm'
    ]);
    var _useSelector = useSelector(function(state) {
        return {
            job: state.jobsReducer.job,
            currentUser: state.profileReducer.userProfile,
            userProfileState: state.profileReducer.userProfileState,
            selectedPayMode: state.order.selectedPayMode,
            membershipPriceId: state.order.membershipPriceId,
            paymentMethodId: state.order.paymentMethodId,
            discountCode: state.order.discountCode
        };
    }), job = _useSelector.job, currentUser = _useSelector.currentUser, userProfileState = _useSelector.userProfileState, selectedPayMode = _useSelector.selectedPayMode, membershipPriceId = _useSelector.membershipPriceId, paymentMethodId = _useSelector.paymentMethodId, discountCode = _useSelector.discountCode;
    var isAssignedPayment = selectedPayMode === PAY_MODE.ASSIGNED_PAYMENT;
    var handleSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(jobIdToAssign, values) {
            var success, success1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(isAssignedPayment && values)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            dispatch(assignPayment(membershipPriceId, jobIdToAssign, values.payerEmail, values.payerName, values.message))
                        ];
                    case 1:
                        success = _state.sent();
                        if (success) {
                            history.push({
                                pathname: routes.payment.assignedStatus(),
                                state: {
                                    payerEmail: values.payerEmail,
                                    payerName: values.payerName
                                }
                            });
                        }
                        return [
                            3,
                            5
                        ];
                    case 2:
                        if (!discountCode) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            dispatch(createDiscountCode(discountCode))
                        ];
                    case 3:
                        success1 = _state.sent();
                        if (!success1) {
                            return [
                                2
                            ];
                        }
                        _state.label = 4;
                    case 4:
                        amplitudeTrack(PAYMENT_FLOW.EVENT, {
                            action: PAYMENT_FLOW.CONTINUE_TO_CONFIRMATION
                        });
                        nextStep();
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(jobIdToAssign, values) {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect(function() {
        dispatch(sendLead(jobId, LEAD_PAYMENT_PAGE));
    }, []);
    var handleSelectedPayMode = function(event) {
        return dispatch(setSelectedPayMode(event.currentTarget.value));
    };
    return /*#__PURE__*/ React.createElement(PaymentMethodStep, {
        job: job,
        isAssignedPayment: isAssignedPayment,
        handleSelectedPayMode: handleSelectedPayMode,
        onAddCard: nextStep,
        handleSubmit: function(values) {
            return handleSubmit(jobId, values);
        },
        currentUser: currentUser,
        userProfileState: userProfileState,
        selectedPayMode: selectedPayMode,
        paymentMethodId: paymentMethodId,
        onPaymentMethodChange: function(paymentMethodId) {
            return dispatch(setPaymentMethodId(paymentMethodId));
        },
        nextButtonProps: {
            label: text(isAssignedPayment ? 'sendQuote' : isBreakpointEnabled ? 'continue' : 'continueToConfirmation')
        }
    });
};
export default OrderWizardPaymentMethod;
